<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <circle cx="12.5" cy="12.5" r="10.5" stroke="black" stroke-width="2" />
    <path
      d="M10 8.7C10 7.8 11.12 6 13 6C14.484 6 16 6.5 16 8.16C16 10.1982 12.9059 11.181 12.5 13.2C12.3719 13.8374 12.5 15 12.5 15"
      stroke="black"
      stroke-width="2"
    />
    <rect x="12" y="17.5" width="1" height="1" fill="currentColor" stroke="currentColor" />
  </svg>
</template>
